import { Media } from '../model/Entities';

const DRAFT_PATH = '/draft';

class MediaService {
    /**
     * Returns the urls where the video of a media may be available, in the order they have to be tried.
     * An uploaded video stays in the 'draft' folder of the S3 bucket until a lambda processes it (creates the
     * thumbnail and adds the watermark). Until that happens the url returned by the API responds with an
     * AccessDenied error, so the draft url has to be used as a fallback (the iOS app does the same). The player
     * renders one <source> per url, so the browser falls back to the next one whenever a url cannot be loaded.
     * @param media - the media
     * @returns the urls of the video, or undefined when the media has no video
     */
    getVideoUrls = (media?: Media): string[] | undefined => {
        const url = media?.url;
        if (!url) {
            return undefined;
        }
        const draftUrl = mediaService.getDraftUrl(url);
        return draftUrl ? [url, draftUrl] : [url];
    };

    /**
     * Returns the url of a media in the 'draft' folder of the S3 bucket.
     * @param url - the url of the media
     * @returns the draft url, or undefined when it cannot be built
     */
    getDraftUrl = (url: string): string | undefined => {
        try {
            const draftUrl = new URL(url);
            if (draftUrl.pathname.startsWith(`${DRAFT_PATH}/`)) {
                return undefined;
            }
            draftUrl.pathname = `${DRAFT_PATH}${draftUrl.pathname}`;
            return draftUrl.toString();
        } catch (error) {
            return undefined;
        }
    };
}

const mediaService: MediaService = new MediaService();
export default mediaService;
